export function getDatasetName (dataset, localize) {
  if (dataset !== 0 && !dataset) {
    if (localize) return localize('Common.Default')
    else return 'Default'
  } else return dataset
}



// WEBPACK FOOTER //
// ./src/utils/outputReports.js